import { useEffect, useState } from 'react'

export const repeatedTextShadow = (
    levels: number,
    color: string,
    additionnalRule?: string
) => {
    const rules: string[] = []
    for (let i = -levels; i <= levels; i++) {
        for (let j = -levels; j <= levels; j++) {
            rules.push(`${i}px ${j}px 0 ${color}`)
        }
    }

    if (additionnalRule) {
        rules.push(additionnalRule)
    }

    return rules.join(',')
}

export const useWindowDimensions = (): { width: number, height: number } => {
    const [width, setWidth] = useState(window.innerWidth)
    const [height, setHeight] = useState(window.innerHeight)
    useEffect(() => {
        const updater = () => {
            setWidth(window.innerWidth)
            setHeight(window.innerHeight)
        }
        window.addEventListener('resize', updater)
        return () => window.removeEventListener('resize', updater)
    })

    return { width, height }
}
